import { Utils } from "neo-common";
import { Communication } from "neo-games";
import { BetManager } from "../../Managers/BetManager";
import { DataManager } from "../../Managers/DataManager";
import { GameManager } from "../../Managers/GameManager";
import { MessageManager } from "../../Managers/MessageManager";
import { RouletteController } from "./RouletteController";

export class RouletteModel {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private static GameRequest: GameClientRequest = null;

    protected controller: RouletteController;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(controller: RouletteController) {
        this.controller = controller;
    }

    //******************************************************************************************************************
    //  REQUESTS
    //******************************************************************************************************************

    public spin(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;

        RouletteModel.GameRequest = {} as GameClientRequest;
        RouletteModel.GameRequest.module = Communication.Game.GameModules.Roulette;
        RouletteModel.GameRequest.bets = BetManager.createBetForSpin();
        RouletteModel.GameRequest.lastChip = BetManager.Chip;
        RouletteModel.GameRequest.callBackFcn = this.spinReceived.bind(this);

        DataManager.controlAutoplay();
        GameManager.gameClient
            .rouletteSpin(Communication.Game.GameModules.Roulette, BetManager.createBetForSpin(), BetManager.Chip)
            .then((response: any): any => {
                MessageManager.postpone(this.spinReceived.bind(this), response);
            });
    }

    public static spinContinue(): void {
        if (!GameManager.requestSend && RouletteModel.GameRequest) {
            GameManager.requestSend = true;

            GameManager.gameClient
                .rouletteSpin(
                    RouletteModel.GameRequest.module,
                    RouletteModel.GameRequest.bets,
                    RouletteModel.GameRequest.lastChip,
                )
                .then((response: any): any => {
                    MessageManager.postpone(RouletteModel.GameRequest.callBackFcn, response);
                });
        }
    }

    //******************************************************************************************************************
    //  RESPONSES
    //******************************************************************************************************************

    protected spinReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            RouletteModel.GameRequest = null;
            this.controller.spinReceived();
        }

        GameManager.requestSend = false;
    }
}

export type GameClientRequest = {
    module: string;
    bets: Array<Communication.Game.RouletteSpinBet>;
    lastChip: number;
    callBackFcn: () => void;
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Roulette/RouletteModel.ts
 **/